/**
 * Valid field names for Dental HMO benefits
 *
 * Used to filter out extraneous fields when transforming to API format.
 * Includes API-specific fields (dhmoBenefits, serviceWaitingPeriods)
 * and admin fields (annualOpenEnrollment, employerContribution).
 */

export const DENTAL_HMO_VALID_FIELDS = new Set([
  "objectType",
  "dhmoBenefits",
  "serviceWaitingPeriods",
  "annualOpenEnrollment",
  "employerContribution",

  // Extended (non-v5) fields — CD-1659/CD-1660
  "extended",
]);
